<template>
  <div>
    <div class="device_content" v-if="deviceType == 0">
      <el-descriptions
        :column="1"
        :class="[$i18n.locale == 'zh-CN' ? '' : 'my_descriptions']"
      >
        <el-descriptions-item :label="$t('lang.设备类型')">{{
          deviceData.deviceTypeName
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.资产号')"
          >{{ deviceData.tagNo }}
          <span class="btn_elect red" v-if="deviceData.status == 10">{{
            $t("lang.继电器故障")
          }}</span>
          <span class="btn_elect blue" v-else-if="deviceData.status == 1">{{
            $t("lang.通电")
          }}</span>
          <span class="btn_elect red" v-else-if="deviceData.status == 0">{{
            $t("lang.断电")
          }}</span>
          <span class="btn_elect red" v-else>{{ $t("lang.离线") }}</span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.总用电量')">
          {{ deviceData.totalKwh | isKwh }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.剩余电量3')">
          {{ deviceData.remainKwh | isKwh }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.电价')">
          {{ deviceData.price || "--" }}
          {{ monetary }}/kW·h
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.电流')">
          <span v-if="!isThreePhase">{{ current }}</span>
          <div v-else class="threeTable">
            <span>A:{{ readingData.Ia }}A</span>
            <span>B:{{ readingData.Ib }}A</span>
            <span>C:{{ readingData.Ic }}A</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.电压')">
          <span v-if="!isThreePhase">{{ voltage }}</span>
          <div v-else class="threeTable">
            <span>A:{{ readingData.Ua }}V</span>
            <span>B:{{ readingData.Ub }}V</span>
            <span>C:{{ readingData.Uc }}V</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.wifi账号')">
          {{ wifiAccount }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.wifi密码')">
          {{ wifiPassword }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.刷新时间')">
          {{ deviceData.dataTime || "--" }}
        </el-descriptions-item>
      </el-descriptions>
      <div
        :class="[
          'operation_box',
          $i18n.locale == 'zh-CN' ? '' : 'en_operation_box',
        ]"
      >
        <div class="oper_item" v-for="item in deviceOperImg" :key="item.type">
          <img :src="item.img" alt="" @click="onClickOperBtn(item.type)" />
          <p>{{ $t("lang." + item.title) }}</p>
        </div>
      </div>
    </div>
    <div class="device_content_water" v-else-if="deviceType == 1">
      <el-descriptions
        :column="1"
        :class="[$i18n.locale == 'zh-CN' ? '' : 'my_descriptions']"
      >
        <el-descriptions-item :label="$t('lang.设备类型')">{{
          deviceData.deviceTypeName
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('lang.资产号')"
          >{{ deviceData.tagNo }}
          <span class="btn_elect red" v-if="deviceData.status == 10">{{
            $t("lang.阀控故障")
          }}</span>
          <span class="btn_elect blue" v-else-if="deviceData.status == 1">{{
            $t("lang.开阀")
          }}</span>
          <span class="btn_elect red" v-else-if="deviceData.status == 0">{{
            $t("lang.关阀")
          }}</span>
          <span class="btn_elect red" v-else>{{ $t("lang.离线") }}</span>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.总用水量')">
          {{ deviceData.totalTon | isUnit }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.剩余水量2')">
          {{ deviceData.remainTon | isUnit }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.当月用水量')">
          {{ deviceData.monthUseTon | isUnit }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.昨日用水量')">
          {{ deviceData.dayUseTon | isUnit }}
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.水价')">
          {{ deviceData.price || "--" }}
          {{ monetary }}/m³
        </el-descriptions-item>
        <el-descriptions-item :label="$t('lang.刷新时间')">
          {{ deviceData.dataTime || "--" }}
        </el-descriptions-item>
      </el-descriptions>
      <div
        :class="[
          'operation_box',
          $i18n.locale == 'zh-CN' ? '' : 'en_operation_box',
        ]"
      >
        <div
          class="oper_item"
          v-for="item in deviceWaterOperImg"
          :key="item.type"
        >
          <img :src="item.img" alt="" @click="onClickWaterOperBtn(item.type)" />
          <p>{{ $t("lang." + item.title) }}</p>
        </div>
      </div>
    </div>

    <!-- 更换租客 -->
    <TenantsDialog ref="tenantsDialogRef" />
    <!-- 代客充值 -->
    <RechargeDialog ref="rechargeDialogRef" />
    <!-- 电表刷新 -->
    <DeviceRefreshDialog ref="deviceRefreshDialogRef" />
    <!-- 修改价格 -->
    <DeviceEditDialog ref="deviceEditDialogRef" />
    <!-- 修改水表价格 -->
    <DeviceEditWaterDialog ref="deviceEditWaterDialogRef" />
    <!-- TokenDialog -->
    <TokenDialog ref="tokenDialogRef" />
    <!-- 阈值设置 -->
    <ThresholdDialog ref="thresholdDialogRef" />
    <WaterRechargeDialog ref="waterRechargeDialogRef" />
  </div>
</template>

<script>
import { deviceOperImg, deviceWaterOperImg } from "../../define.js";
import TenantsDialog from "../../dialog/tenants-dialog.vue";
import RechargeDialog from "../../dialog/recharge-dialog.vue";
import DeviceRefreshDialog from "../../dialog/deviceRefresh-dialog.vue";
import DeviceEditDialog from "../../dialog/deviceEdit-dialog.vue";
import TokenDialog from "../../dialog/token-dialog.vue";
import ThresholdDialog from "../../dialog/threshold-dialog.vue";
import { mapActions } from "vuex";
import DeviceEditWaterDialog from "../../dialog/deviceEditWater-dialog";
import WaterRechargeDialog from "../../dialog/water-recharge-dialog";
export default {
  components: {
    WaterRechargeDialog,
    DeviceEditWaterDialog,
    TenantsDialog,
    RechargeDialog,
    DeviceRefreshDialog,
    DeviceEditDialog,
    TokenDialog,
    ThresholdDialog,
  },
  inject: ["equipmentPage"],
  data() {
    return {
      deviceOperImg: deviceOperImg,
      deviceWaterOperImg: deviceWaterOperImg,
      deviceData: "",
      deviceType: 0,
      voltage: "--",
      current: "--",
      wifiAccount: "--",
      wifiPassword: "--",
      readingData: {},
      isThreePhase: false,
      monetary: "元",
    };
  },
  filters: {
    isKwh(val) {
      if (val === undefined || val === null || val === "") return "--";
      return val + "kW·h";
    },
    isUnit(val) {
      if (val === undefined || val === null || val === "") return "--";
      return val + "m³";
    },
  },
  methods: {
    ...mapActions({
      deviceIsPoweredOn: "ZD_DeviceIsPoweredOn",
      deviceIsPoweredOff: "ZD_DeviceIsPoweredOff",
      eliminateElectricityTheft: "ZD_EliminateElectricityTheft",
      deviceClearing: "ZD_DeviceClearing",
      meterDeviceDetails: "ZD_MeterDeviceDetails",
      meterDeviceWaterDetails: "ZD_MeterDeviceWaterDetails",
      waterOptValveOpen: "ZD_WaterOptValveOpen",
      waterOptValveClose: "ZD_WaterOptValveClose",
      waterOptClearEnergy: "ZD_WaterOptClearEnergy",
    }),
    /**操作 1-更换租客 2-代客充值 3-通电 4-断电 5-刷新 6-清窃电 7-清零 8-修改价格 */
    onClickOperBtn(type) {
      switch (type) {
        case 1:
          this.$refs.tenantsDialogRef.showDialog(
            { ...this.deviceData, deviceType: this.deviceType },
            2
          );
          break;
        case 2:
          this.$refs.rechargeDialogRef.showDialog(this.deviceData);
          break;
        case 3:
          this.TipsDialog(
            this.$t("lang.您是否确认通电"),
            "deviceIsPoweredOn",
            this.$t("lang.通电")
          );
          break;
        case 4:
          this.TipsDialog(
            this.$t("lang.您是否确认断电"),
            "deviceIsPoweredOff",
            this.$t("lang.断电")
          );
          break;
        case 5:
          this.$refs.deviceRefreshDialogRef.showDialog(this.deviceData.pointId);
          break;
        case 6:
          this.TipsDialog(
            this.$t("lang.您是否要清窃电"),
            "eliminateElectricityTheft",
            this.$t("lang.清窃电")
          );
          break;
        case 7:
          this.TipsDialog(
            this.$t("lang.您是否要清电量"),
            "deviceClearing",
            this.$t("lang.清零")
          );
          break;
        case 8:
          this.$refs.deviceEditDialogRef.dialogVisibleShow(2, this.deviceData);
          break;
        case 9:
          this.$refs.thresholdDialogRef.showDialog(this.deviceData.pointId);
          break;
      }
    },
    /**水表操作 1-更换租客 2-代客充值 3-开阀 4-关阀 5-清零 6-修改价格  */
    async onClickWaterOperBtn(type) {
      switch (type) {
        case 1:
          this.$refs.tenantsDialogRef.showDialog(
            { ...this.deviceData, deviceType: this.deviceType },
            2
          );
          break;
        case 2:
          this.$refs.waterRechargeDialogRef.showDialog(this.deviceData);
          break;
        case 3:
          this.WaterTipsDialog(
            this.$t("lang.您是否确认开阀"),
            "waterOptValveOpen",
            this.$t("lang.开阀")
          );
          break;
        case 4:
          this.WaterTipsDialog(
            this.$t("lang.您是否确认关阀"),
            "waterOptValveClose",
            this.$t("lang.关阀")
          );
          break;
        case 5:
          this.WaterTipsDialog(
            this.$t("lang.您是否要清水量"),
            "waterOptClearEnergy",
            this.$t("lang.水表清零")
          );
          break;
        case 6:
          this.$refs.deviceEditWaterDialogRef.dialogVisibleShow(
            2,
            this.deviceData
          );
          break;
        default:
          break;
      }
    },
    TipsDialog(text, interfaceName, tispText) {
      this.$confirm(text, this.$t("lang.提示"), {
        confirmButtonText: this.$t("lang.确定"),
        cancelButtonText: this.$t("lang.取消"),
        type: "warning",
      })
        .then(async () => {
          let fullScreenLoading = this.$loading({
            lock: true,
            text: this.$t("lang.加载中"),
            spinner: "el-icon-loading font34",
            background: "rgba(255, 255, 255, 0.5)",
            customClass: "myLoading",
          });
          try {
            let res = await this[interfaceName]({
              pointId: this.deviceData.pointId,
            });
            if (res.success !== 1) return;
            this.$message({
              type: "success",
              message: this.$t("lang.操作成功"),
            });
            if (res.value.token) {
              this.$refs.tokenDialogRef.showDialog(res.value.token, tispText);
            }
            setTimeout(() => {
              this.equipmentPage.$refs.rightDeviceRef.onClickQuery();
              // this.equipmentPage.$refs.rightDeviceRef.onClickDetails(
              //   this.deviceData.pointId
              // );
            }, 3000);
          } catch {
          } finally {
            fullScreenLoading.close();
          }
        })
        .catch(() => {});
    },
    WaterTipsDialog(text, interfaceName, tispText) {
      this.$confirm(text, this.$t("lang.提示"), {
        confirmButtonText: this.$t("lang.确定"),
        cancelButtonText: this.$t("lang.取消"),
        type: "warning",
      })
        .then(async () => {
          if (this.isnull(interfaceName))
            return this.$message.warning(this.$t("lang.水表操作提醒"));
          let fullScreenLoading = this.$loading({
            lock: true,
            text: this.$t("lang.加载中"),
            spinner: "el-icon-loading font34",
            background: "rgba(255, 255, 255, 0.5)",
            customClass: "myLoading",
          });
          try {
            let res = await this[interfaceName]({
              pointId: this.deviceData.pointId,
            });
            if (res.success !== 1) return;
            this.$message({
              type: "success",
              message: this.$t("lang.操作成功"),
            });
            if (res.value.token) {
              this.$refs.tokenDialogRef.showDialog(res.value.token, tispText);
            }
            setTimeout(() => {
              this.refreshData();
              setTimeout(() => {
                this.equipmentPage.$refs.rightDeviceRef.onClickQuery();
              }, 1000);
            }, 1000);
          } catch {
          } finally {
            fullScreenLoading.close();
          }
        })
        .catch(() => {});
    },
    async refreshData() {
      let res = {};
      switch (this.deviceType) {
        case 0:
          res = await this.meterDeviceDetails({
            pointId: this.deviceData.pointId,
          });
          if (res.success !== 1) return;
          this.deviceData = res.value;
          break;
        case 1:
          res = await this.meterDeviceWaterDetails({
            pointId: this.deviceData.pointId,
          });
          if (res.success !== 1) return;
          this.deviceData = res.value;
          break;
        default:
          break;
      }
    },
    dataShow(data, deviceType) {
      this.deviceData = data;
      this.deviceType = deviceType;
      this.voltage = "--";
      this.current = "--";
      this.wifiAccount = "--";
      this.wifiPassword = "--";
      this.readingData = {};
      this.isThreePhase = false;
    },
  },
};
</script>

<style scoped lang='less'>
.device_content {
  margin-top: 5px;
  background: #eef4fa;
  border-radius: 4px;
  height: 610px;
  padding: 24px 44px;
  font-size: 14px;
}
.device_content_water {
  margin-top: 5px;
  background: #eef4fa;
  border-radius: 4px;
  height: 610px;
  padding: 24px 44px;
  font-size: 14px;
}
/deep/.el-descriptions__body {
  background: #eef4fa;
}
.my_descriptions /deep/ .el-descriptions-item__label {
  width: 200px !important;
}
/deep/ .el-descriptions-item__label {
  min-width: 75px;
  margin-right: 35px;
}
/deep/ .el-descriptions-item {
  padding-bottom: 20px !important;
}
.btn_elect {
  position: absolute;
  margin-left: 120px;
  margin-top: -2px;
  min-width: 48px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  color: #fff;
  padding: 0 4px;
}
.blue {
  background: #5eacfc;
}
.red {
  background: #fc8b8b;
}
.en_operation_box {
  .oper_item {
    margin-right: 17px !important;
    width: 88px !important;
    margin-bottom: 10px !important;
  }
  .oper_item:nth-of-type(5) {
    margin: 0 !important;
  }
  p {
    white-space: wrap !important;
  }
}
.operation_box {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  .oper_item:nth-of-type(6) {
    margin: 0;
  }
  .oper_item {
    width: 44px;
    margin-right: 44px;
    margin-bottom: 30px;
    text-align: center;
    img {
      height: 40px;
      cursor: pointer;
    }
    p {
      text-align: center;
      font-size: 12px;
      color: #333;
      white-space: nowrap;
    }
  }
}
/deep/ .el-descriptions-item__label.has-colon:after {
  top: 0 !important;
}
.threeTable span {
  display: inline-block;
  width: 95px;
}
</style>
